const DISPLAY_SERVER_ERROR_AT = {
  FIELD: 'FIELD',
  PAGE: 'PAGE',
};

const EXIT_CTA_LABEL = {
  BACK_TO_LISTING: 'Back to listing',
  EXIT: 'Exit',
  SAVE_AND_EXIT: 'Save & exit',
};

export { DISPLAY_SERVER_ERROR_AT, EXIT_CTA_LABEL };
